<div
  *ngIf="cursor$ | async as cursor"
  id="cursor"
  [style.content]="cursor.url"
  [style.transform]="cursor.transform"
  class="cursor-container"
></div>
